<template>
  <div id="bank-account-infomation-tab">
    <div class="float-right">
      <primary-button class="button" @click="addBankAccount"  blue rounded-corner :text="$t('ADD')">
        <template v-slot:icon>
          <font-awesome-icon class="icon" :icon="faPlus" />
        </template>
      </primary-button>
    </div>

    <bank-account-modal v-model="on" :bankAccount="bankAccount" :checkEdit="checkEdit"/>
    <table>
      <thead>
        <tr>
          <th>{{ $t('FULL_NAME') }}</th>
          <th>{{ $t('BANK_NAME') }}</th>
          <th>{{ $t('ACCOUNT_NUMBER') }}</th>
          <th>{{ $t('BANK_BRANCH') }}</th>
          <th>{{ $t('EDIT') }}</th>
          <th>{{ $t('DELETE') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="clientBankAccount.id" v-for="clientBankAccount in clientBankAccounts">
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('FULL_NAME') }}:</div>
            <div>{{ clientBankAccount.bankAccountName }}</div>
          </td>
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('BANK_NAME') }}:</div>
            <div>{{ clientBankAccount.bankName }}</div>
          </td>
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('ACCOUNT_NUMBER') }}:</div>
            <div>{{ clientBankAccount.bankAccountNo }}</div>
          </td>
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('BANK_BRANCH') }}:</div>
            <div>{{ clientBankAccount.bankBranch || null }}</div>
          </td>
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('EDIT') }}:</div>
            <div><font-awesome-icon class="pointer" @click="() => editInfo(clientBankAccount)" :icon="faPencilAlt" /></div>
          </td>
          <td>
            <div class="mobile-header" v-if="isMobile">{{ $t('DELETE') }}:</div>
            <div><font-awesome-icon class="pointer" @click="() => deleteBankAccount(clientBankAccount.id)" :icon="faTrash" /></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { faPlus, faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PrimaryButton from '@/components/PrimaryButton';

import ClientDetailServices from '@/views/ClientDetail/ClientDetailServices';
import BankAccountModal from './BankAccountModal';

const { useState, useActions } = createNamespacedHelpers('clientDetail');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useActions: useConfirmActions } = createNamespacedHelpers('confirm');
const { useActions: useModalActions } = createNamespacedHelpers('modal');
const { useState: useStateApp } = createNamespacedHelpers('app');

export default {
  name: 'BankAccountInfomationTab',
  components: {
    PrimaryButton,
    FontAwesomeIcon,
    BankAccountModal
  },
  setup(props, { root }) {
    const { clientBankAccounts } = useState(['clientBankAccounts']);
    const { getClientBankAccounts } = useActions(['getClientBankAccounts']);
    const { info } = useFlashActions(['info', 'error']);
    const { setTitleModal, setOnConfirm } = useConfirmActions(['setTitleModal', 'setOnConfirm']);
    const { toggleConfirmModal } = useModalActions(['toggleConfirmModal']);
    const { isMobile } = useStateApp(['isMobile']);

    const { id: clientId } = root.$route.params;

    const on = ref(false);
    const checkEdit = ref(false);
    const bankAccount = ref(null);

    const addBankAccount = () => {
      on.value = !on.value;
      checkEdit.value = false;
    };

    const editInfo = async (clientBankAccount) => {
      checkEdit.value = true;
      bankAccount.value = clientBankAccount;
      on.value = !on.value;
    };

    const deleteBankAccount = async (id) => {
      setTitleModal(root.$t('CONFIRM_DELETE_BANK_ACCOUNT'));

      const onConfirm = async () => {
        await ClientDetailServices.deleteBankAccount(id);
        info('DELETE_SUCCESSFULLY');
        getClientBankAccounts(clientId);
      };

      setOnConfirm(onConfirm);
      toggleConfirmModal();
    };

    onMounted(() => {
      getClientBankAccounts(clientId);
    });
    return {
      faPlus,
      faTrash,
      faPencilAlt,
      on,
      clientBankAccounts,
      deleteBankAccount,
      addBankAccount,
      editInfo,
      checkEdit,
      bankAccount,
      isMobile
    };
  },
};
</script>

<style lang="scss" scoped>
 @import "~@/assets/scss/colors";

#bank-account-infomation-tab{
  padding-top: 20px;
  border-radius: 3px;

  .button {
    margin: 0px 3px;
    .icon {
      padding-top: 5px;
    }
  }

  table {
    padding-top: 15px;
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;

    thead {
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;

      tr {

        th {
          background-color: $brightMaroon;
          color: $white;
          padding: 15px 10px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        background-color: $babyPowder;
        transition: all .2s ease-in-out;

        &:hover {
          background-color: $ghostWhite;
        }

        td {
          padding: 15px 5px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }
        }
      }
    }
  }

  .pointer {
    cursor: pointer;
  }

  @media (max-width: 767px) {

    table {
      padding-top: 50px;
      width: auto;
      display: block;

      thead {
        display: block;

        tr {
          position: absolute;
          top: -9999px;
          left: -9999px;
        }
      }

      tbody {
        text-align: start;
        display: block;

        tr {
          display: block;

          &:last-child {
            border-bottom: 1px solid $alto;
          }

          td {
            padding: 2px;
            display:block;
            border: none;
            position: relative;
            padding-left: 45%;
            padding-right: 6px;
            min-height: 30px;

            &:first-child {
              border-left: unset;
              border-top: 1px solid $alto;
              padding-top: 20px;
              border-top-left-radius: unset;
            }

            &:last-child {
              border-right: unset;
              padding-bottom: 20px;
            }

            &::before {
              position: absolute;
              top: 0;
              left: 6px;
              width: 45%;
              padding-right: 10px;
              white-space: nowrap;
              text-align: center;
            }

            .mobile-header {
              position: absolute;
              left: 6px;
              padding-right: 10px;
              white-space: nowrap;
              text-align: center;
              padding-left: 10px;
            }
          }
        }
      }
    }
  }

}
</style>
